import { motion } from "framer-motion"

interface QuoteIconProps {
  className?: string
  fill?: string
}

const Quote = ({ className, fill }: QuoteIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
    <path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z" />
  </svg>
)

interface QuoteCardProps {
  text: string
  variant?: "white" | "green"
  tailPosition?: "bottom-left" | "bottom-right"
  className?: string
  delay?: number
  index?: number
  inView?: boolean
}

export default function QuoteCard({
  text,
  variant = "white",
  tailPosition = "bottom-left",
  className = "",
  delay = 0,
  index = 0,
  inView = true,
}: QuoteCardProps) {
  const isGreen = variant === "green"

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={
        inView
          ? { opacity: 1, y: 0, scale: 1 }
          : { opacity: 0, y: 20, scale: 0.95 }
      }
      transition={{ duration: 0.5, delay }}
      className={`relative flex max-w-[280px] flex-row gap-2 rounded-2xl p-4 pl-2  shadow-lg ${
        isGreen ? "bg-kkm-green text-slate-800" : "bg-white text-slate-800"
      } ${className}`}
    >
      <Quote
        className={`h-6 w-6 ${isGreen ? "text-white/50" : "text-kkm-lightgreen/70"}`}
        fill="currentColor"
      />
      <p className="relative m-0 w-fit grow-0 text-[15px] font-medium leading-relaxed">
        {text}
      </p>

      {/* Tail */}
      <div
        className={`absolute -bottom-4 h-0 w-0 border-l-[16px] border-r-[16px] border-t-[20px] border-l-transparent border-r-transparent ${
          isGreen ? "border-t-kkm-green" : "border-t-white"
        } ${tailPosition === "bottom-left" ? "left-8" : "right-8"}`}
      />
    </motion.div>
  )
}
